import { render, staticRenderFns } from "./AutoCreateCard.vue?vue&type=template&id=3e072cbc&scoped=true"
import script from "./AutoCreateCard.vue?vue&type=script&lang=js"
export * from "./AutoCreateCard.vue?vue&type=script&lang=js"
import style0 from "./AutoCreateCard.vue?vue&type=style&index=0&id=3e072cbc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e072cbc",
  null
  
)

export default component.exports